import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const GET_SUPPLIES_REQUEST = 'GET_SUPPLIES_REQUEST';
export const GET_SUPPLIES_SUCCESS = 'GET_SUPPLIES_SUCCESS';
export const GET_SUPPLIES_ERROR = 'GET_SUPPLIES_ERROR';


export const getSupplies = (data) => {
    let headers = getHeaderWithToken();
    let start = data && data.start;
    let length = data && data.length;
    let search = data && data.search;

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: GET_SUPPLIES_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/supply`,
                headers: headers,
                params: { start, length, search },
            }).then(function (response) {
                dispatch({
                    type: GET_SUPPLIES_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: GET_SUPPLIES_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
